import { Input } from 'antd';
import { jsonValidator } from '../utils/format';

/** Re-export validator để dùng trong các Form.Item. */
export const jsonRule = { validator: jsonValidator };

/** Ô nhập JSON nhiều dòng dùng chung cho các form. */
export default function JsonTextArea({
  value,
  onChange,
  rows = 6,
  placeholder,
}: {
  value?: string;
  onChange?: (v: string) => void;
  rows?: number;
  placeholder?: string;
}) {
  return (
    <Input.TextArea
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      rows={rows}
      spellCheck={false}
      placeholder={placeholder ?? '{ }'}
      style={{ fontFamily: 'monospace', fontSize: 13 }}
    />
  );
}
